import { render, staticRenderFns } from "./top-bar-exploitation-menu.vue?vue&type=template&id=66fbd3a5&"
import script from "./top-bar-exploitation-menu.vue?vue&type=script&lang=js&"
export * from "./top-bar-exploitation-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports